export const releaseMdString = `

We're excited to announce the release of **version 3.11** of the ecoinvent database. This release expands the breadth of our data, offering new insights and enhanced accuracy for various industries. 

&nbsp;
&nbsp;

##### Highlights - Version 3.11:

- **Fuels**: Revised natural gas data for 57 countries, updated estimates for pipeline and LNG transport, and improved data for coal and lignite production, with enhanced regional details.
 
- **Energy:** Updated electricity market mixes for all countries with 2021 data and 2022 data for Brazil, China, and Switzerland.
 
- **Chemicals and Plastics:** Improved data coverage for key chemical precursors (e.g., carbon monoxide), polyvinyl chloride, unsaturated polyester/vinyl ester resins, and new composites manufacturing datasets.
 
- **Batteries:** New datasets for lithium-ion chemistries, including NMC532 and NMC622, new and updated datasets for natural graphite and synthetic graphite, and expanded coverage of salts and electrolytes for emerging technologies of sodium-ion batteries.
 
- **Building and Construction:** New cement and clinker production data reflecting specific Canadian regional practices and updates covering a variety of building materials.
 
- **Waste:** Regionalized municipal waste treatment data for 27 EU countries, Switzerland, Norway, Iceland, and the United Kingdom, plus new datasets on mechanical and chemical recycling processes of waste plastic in Europe and China.
 
- **Agriculture:** 136 new datasets for crops across different regions in Switzerland covering conventional and organic farming methods.
 
- **Transport:** Updates to the circulating fleet of passenger vehicles and new datasets on aircraft maintenance.
 
- **LCIA methods:** Revised and updated modeling of biogenic carbon flows to allow for extended climate change assessment including biogenic carbon dioxide.
 
For further details about everything included in version 3.11, visit our [Knowledge Base](https://support.ecoinvent.org/ecoinvent-version-3.11).

&nbsp;
&nbsp; 

##### Version 3.10.1

We identified two significant issues in version 3.10 of the ecoinvent database, which affects certain impact assessment indicators across all system models. To address these issues, we have released **version 3.10.1** concurrently with version 3.11 to provide fixes for users of version 3.10.

- **For users of version 3.10:** We recommend upgrading to version 3.10.1, especially if their work involves the affected impact categories or unit process data related to coke production or Brazilian electricity markets. 
 
- **For users of earlier versions:** These issues do not affect your work. When you upgrade to the latest version, we advise starting directly with version 3.10.1 or 3.11. 
 
For detailed information about version 3.10.1, please refer to our [Knowledge Base](https://support.ecoinvent.org/ecoinvent-version-3.10.1).
`;
